<template>
  <div class="documentation">
    <Breadcumb title="Modifier un document pédagogique" :breadcumb-data="breadcumbData"></Breadcumb>
    <b-card class="cardcontainer">
      <b-form @submit="editDocument">
        <input v-model="document_id" type="hidden" />
        <b-form-group label="Catégorie" label-align-md="right" label-class="pr-md-2" :label-cols-md="2">
          <b-select value="Choisir une catégorie de document" v-model="category_id" :options="categoryData"/>
        </b-form-group>
        <b-form-group label="Nom en anglais" label-align-md="right" label-class="pr-md-2" :label-cols-md="2">
          <b-input type="text" placeholder="Label" v-model="label_en" :state="errors['label_en'] ? 'invalid': ''"/>
          <div v-if="errors['label_en']" class="invalid-tooltip">{{ errors['label_en'][0] }}</div>
        </b-form-group>
        <b-form-group label="Nom en Français" label-align-md="right" label-class="pr-md-2" :label-cols-md="2">
          <b-input type="text" placeholder="Label français" v-model="label" :state="errors.label ? 'invalid': ''"/>
          <div v-if="errors['label']" class="invalid-tooltip">{{ errors['label'][0] }}</div>
        </b-form-group>
        <b-form-group label="Description en anglais" label-align-md="right" label-class="pr-md-2" :label-cols-md="2">
          <b-textarea placeholder="Description en anglais" :rows="3" v-model="description_en"/>
        </b-form-group>
        <b-form-group label="Description en français" label-align-md="right" label-class="pr-md-2" :label-cols-md="2">
          <b-textarea placeholder="Description en français" :rows="3" v-model="description"/>
        </b-form-group>
        <div :style="fileType === 'document' ? 'display: block' : 'display: none'">
          <b-form-group label="Document en anglais" label-align-md="right" label-class="pr-md-2" :label-cols-md="2">
            <b-file v-model="document_en" ref="document_en"/>
          </b-form-group>
          <b-form-group label="Document en français" label-align-md="right" label-class="pr-md-2" :label-cols-md="2">
            <b-file v-model="document" ref="document"/>
          </b-form-group>
        </div>
        <div :style="fileType === 'video' ? 'display: block' : 'display: none'">
          <b-form-group label="Lien vidéo en anglais" label-align-md="right" label-class="pr-md-2" :label-cols-md="2">
            <b-textarea placeholder="Video en anglais" :rows="3" v-model="video_en"/>
          </b-form-group>
          <b-form-group label="Lien vidéo en français" label-align-md="right" label-class="pr-md-2" :label-cols-md="2">
            <b-textarea placeholder="Video en français" :rows="3" v-model="video"/>
          </b-form-group>
        </div>
        <div :style="fileType === 'article' ? 'display: block' : 'display: none'">
          <b-form-group label="Article en anglais" label-align-md="right" label-class="pr-md-2" :label-cols-md="2">
            <b-textarea placeholder="article anglais" :rows="3" v-model="article_en"/>
          </b-form-group>
          <b-form-group label="Article en français" label-align-md="right" label-class="pr-md-2" :label-cols-md="2">
            <b-textarea placeholder="article" :rows="3" v-model="article"/>
          </b-form-group>
        </div>
        <b-form-group label="Vignette" label-align-md="right" label-class="pr-md-2" :label-cols-md="2">
          <b-file v-model="preview" ref="preview" />
        </b-form-group>
        <b-form-group label="Cible" label-align-md="right" label-class="pr-md-2" :label-cols-md="2">
          <b-check-group plain v-model="user_types" :options="userTypeData"/>
          <div v-if="errors['user_types']" class="invalid-tooltip">{{ errors['user_types'][0] }}</div>
        </b-form-group>
        <b-form-row>
          <div class="col-md-10 ml-md-auto">
            <b-btn type="submit" variant="primary">Modifier le document</b-btn>
          </div>
        </b-form-row>
      </b-form>
    </b-card>
  </div>
</template>
<script>
  import { ADMIN_EDIT_DOCUMENT_REQUEST, ADMIN_GET_CATEGORIES_REQUEST, ADMIN_GET_DOCUMENT_REQUEST } from '../../_store/administration/document/actiontypes';
  import { ADMIN_GET_USERTYPES_REQUEST} from '../../_store/administration/user/actiontypes'
  import { mapState } from 'vuex';
  import Breadcumb from '../../components/breadcumb';

  function getBase64(file) {
    return new Promise((resolve, reject) => {
      if (file === undefined) {
        return resolve(null);
      } else {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
      }
    });
  }

  export default {
    name: 'adminDocumentationEdit',
    components: {Breadcumb, },
    mounted() {
      this.$store.dispatch(ADMIN_GET_USERTYPES_REQUEST)
        .then(response => {
          this.userTypeData = response.data.usertypes.map(userType => {
            return {
              value: userType.id,
              text: userType.label,
              checked:true
            }
          })
        })
      this.$store.dispatch(ADMIN_GET_CATEGORIES_REQUEST)
        .then(response => {
          this.categoryData = response.data.categories.map(category => {
            return {
              value: category.id,
              text: category.label
            };
          });
          return this.$store.dispatch(ADMIN_GET_DOCUMENT_REQUEST, this.$route.params.id)
        })
        .then(response => {
          this.category_id = response.data.document.category.id,
          this.label_en = response.data.document.label_en,
          this.label = response.data.document.label,
          this.description_en = response.data.document.description_en,
          this.description = response.data.document.description,
          this.document_id = response.data.document.id
          this.user_types = response.data.document.user_types.map(userType => {
            return userType.id
          })
          this.article = response.data.document.article
          this.article_en = response.data.document.article_en
          this.video = response.data.document.video
          this.video_en = response.data.document.video_en
          this.fileType = response.data.document.filetype
        });
    },
    computed: mapState({ errors: state => state.admin_document.errors }),
    data() {
      return ({
        breadcumbData: [
          { text: 'Accueil', href: '/dashboard/' },
          { text: 'Liste des documents pédagogiques', href: '/dashboard/administration/documentation/' },
          { text: 'Modifier un document pédagogique', active: true },
        ],
        fileType: '',
        userTypeData: [],
        user_types: [],
        document_id: 0,
        categoryData: [],
        category_id: 0,
        label_en: '',
        label: '',
        description_en: '',
        description: '',
        document_en: null,
        document: null,
        preview: null
      });
    },
    layout(context) {
      return 'layout';
    },
    methods: {
      editDocument: function (e) {
        e.preventDefault();
        console.log(this.$refs.document.$el.querySelector('input[type=file]').files[0]);
        let payload = {};
        getBase64(this.$refs.document.$el.querySelector('input[type=file]').files[0])
          .then(documentB64 => {
            if (documentB64){
              payload.document = documentB64;
            }
            return getBase64(this.$refs.document_en.$el.querySelector('input[type=file]').files[0]);
          })
          .then(documentFrB64 => {
            if (documentFrB64) {
              payload.document_en = documentFrB64;
            }
            return getBase64(this.$refs.preview.$el.querySelector('input[type=file]').files[0]);
          })
          .then(previewb64 => {
            if (previewb64) {
              payload.preview = previewb64;
            }
            payload.label_en = this.label_en;
            payload.label = this.label;
            payload.description_en = this.description_en;
            payload.description = this.description;
            payload.category = Number(this.category_id);
            payload.id = this.document_id;
            payload.user_types = this.user_types;
            payload.video = this.video;
            payload.video_en = this.video_en;
            payload.article = this.article;
            payload.article_en = this.article_en;
            payload.filetype = this.fileType;
            this.$store.dispatch(ADMIN_EDIT_DOCUMENT_REQUEST, payload)
              .then(() => {
                this.$router.push('/dashboard/administration/documentation/');
              })
              .catch((error) => {
                console.log('error is ==');
                console.log(error);
              });
          });
      }
    },
  };
</script>
